
// => Styling
import styles from './SegmentedControl.module.css';


// ============
// Component
// ============
const SegmentedControl = ({
    items = [{id: "none", label: "None"}],
    activeItem = "none",
    onSelect = (v) => {},
}) => {


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            
            {items.map(e =>
                <div className={[styles.item, activeItem === e.id ? styles.active : null].join(" ")}
                        key={"seg_ctrl_"+e.id}
                        onClick={()=>onSelect(e.id)}>
                    {e.label}
                </div>
            )}

        </div>
    );
}


export default SegmentedControl